module.exports = __webpack_public_path__ + "media/images/main_head-25dcfdc3.png";